<template>
  <div class="adminManage">
    <div class="adminManage_content">
      <div class="notAdmin" v-if="adminList.length==0 || adminList.length==null">暂无管理员</div>
      <div class="adminList" v-else>
        <div class="adminCard" v-for="(item,i) in adminList" :key="i">
          <div class="adminCard_index">{{ parseInt(i+1) }}</div>
          <div class="adminCard_info">
            <div class="infoRow"><span class="label">用户名：</span><span class="value">{{ item.adminname }}</span></div>
            <div class="infoRow"><span class="label">密码：</span><span class="value">{{ item.adminpassword }}</span></div>
            <div class="infoRow"><span class="label">创建时间：</span><span class="value">{{ item.createtime }}</span></div>
          </div>
          <div class="adminCard_actions">
            <span class="actionBtn del" @click="del_admin(i)">删除</span>
            <span class="actionBtn edit" @click="modifyAdminClick(i)">修改</span>
          </div>
        </div>
      </div>
    </div>
    <div class="addBtn" @click="add_admin">+</div>
    <Overlay :show="show">
      <div class="overlayWrapper" @click.stop>
        <div class="block">
          <div class="block_tips">用户名/密码不能超过20个字符</div>
          <div class="block_close" @click="exit_add_overlay">&times;</div>
          <div class="block_title">{{overlay_title}}</div>
          <div class="block_form">
            <Field class="field" placeholder="请输入用户名(仅支持字母)" v-model="modifyAdmin.adminname" maxlength="20" type="text"/>
            <Field class="field" placeholder="请输入密码" v-model="modifyAdmin.adminpassword" type="text" maxlength="20"/>
            <Button type="primary" size="large" class="confirmBtn" @click="loginConfrim">确定</Button>
          </div>
        </div>
      </div>
    </Overlay>
  </div>
</template>
<script setup>
import { computed, getCurrentInstance, onMounted, ref, onBeforeMount } from 'vue';
import { Overlay, Field, Button, showConfirmDialog, showToast  } from 'vant'
import { store } from '@/store/index';
import {useRouter } from 'vue-router';
import 'vant/lib/index.css';
import { createAdmin,modifySecondAdmin,delAdmin } from '@/api/index'
const show = ref(false)
const page = getCurrentInstance()
// Overlay的title
const overlay_title = ref('')
// 修改管理员的角标
const modifyIndex = ref(-1)
const modifyAdmin = ref({adminname:'',adminpassword:'',createtime:''})
const adminList = ref([])

onBeforeMount(async ()=>{
    let secondInfo = JSON.parse(localStorage.getItem('secondRes'))
    console.log(secondInfo)
    if(secondInfo.length>0){
      adminList.value = ([...secondInfo])
    }
})
onMounted(()=>{
})
// 关闭添加用户的页面
const exit_add_overlay = () =>{
  show.value = false
  modifyAdmin.value = {'adminname':'','adminpassword':null,'createtime':''}
}
// 增加管理员
const add_admin = () =>{
  overlay_title.value = '添加管理员'
  show.value = true
}
// 修改用户
const modifyAdminClick = (i)=>{
  modifyAdmin.value = {...adminList.value[i]}
  show.value = true
  overlay_title.value = '修改管理员'
  modifyIndex.value = i
}
//删除管理员
const del_admin = (i)=>{
  showConfirmDialog({
    title: '删除',
    message: '是否确认删除该管理员,删除后无法恢复'
  }).then(() => {
      console.log('OK');
      let {adminname,adminpassword} = adminList.value[i]
      adminList.value.splice(i, 1);
      delAdmin({'adminName':adminname,'adminpassword':adminpassword})
      localStorage.setItem('secondRes',JSON.stringify(adminList.value))
    }).catch(() => {
      console.log('not');
    });
}
//确定按钮
const loginConfrim = ()=>{
  const leg = /^[A-Za-z]+$/i;
  const textLeg = /[\u4e00-\u9fff]/
  if(!leg.test(modifyAdmin.value.adminname)){
    showToast('用户名仅支持字母')
    return
  }
  if(textLeg.test(modifyAdmin.value.adminpassword)){
    showToast('密码不支持汉字')
    return
  }
  if (modifyIndex.value!=-1){
    let {adminname,adminpassword} = adminList.value[modifyIndex.value]
    let mdyDate = {'mdyAdminName':modifyAdmin.value.adminname,'mdyAdminpassword':modifyAdmin.value.adminpassword,adminName:adminname,adminpassword: adminpassword}
    // console.log(adminList.value[modifyIndex.value])
    modifySecondAdmin({...mdyDate})
    adminList.value[modifyIndex.value] = {...modifyAdmin.value}
    modifyIndex.value = -1
      // modifySecondAdmin()
  }else{
      let date = new Date()
      let year = date.getFullYear()
      let month = date.getMonth()+1
      month = month<10?'0'+month:month
      let day = date.getDate()
      day = day<10?'0'+day:day
      let timer = year+'-'+month+'-'+day
      // console.log(month)
      let createDate = {'adminName':modifyAdmin.value.adminname,'adminpassword':modifyAdmin.value.adminpassword,'createTime':timer}
      createAdmin({...createDate})
      modifyAdmin.value.createtime = timer
      adminList.value.push( { ...modifyAdmin.value})
  } 
  localStorage.setItem('secondRes',JSON.stringify(adminList.value))
  modifyAdmin.value = {'adminname':'','adminpassword':null,'createtime':''}
  show.value = false
}
</script>
  <style scoped>
/* 全局滚动条样式 */
.adminManage ::-webkit-scrollbar {
  width: 4px;
}
.adminManage ::-webkit-scrollbar-track {
  background: #f0f0f0;
  border-radius: 2px;
}
.adminManage ::-webkit-scrollbar-thumb {
  background: #818cf8;
  border-radius: 2px;
}
.adminManage ::-webkit-scrollbar-thumb:hover {
  background: #6366f1;
}

.adminManage {
  width: 100%;
  height: 100%;
  user-select: none;
  background: #f7f8fa;
  position: relative;
}
.adminManage_content {
  width: 100%;
  height: 100%;
  overflow: auto;
  padding: 20px;
  box-sizing: border-box;
}
.notAdmin {
  position: absolute;
  left: 50%;
  top: 50%;
  font-size: 18px;
  color: #bbb;
  transform: translate(-50%, -50%);
}

/* 添加按钮 - 右下角悬浮 */
.addBtn {
  font-size: 22px;
  background: linear-gradient(135deg, #4f46e5, #6366f1, #818cf8);
  position: absolute;
  width: 56px;
  height: 56px;
  text-align: center;
  line-height: 56px;
  color: #fff;
  border-radius: 50%;
  bottom: 30px;
  right: 40px;
  box-shadow: 0 4px 16px rgba(79, 70, 229, 0.4);
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
}
.addBtn:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 20px rgba(79, 70, 229, 0.5);
}
.addBtn:active {
  transform: scale(0.98);
}

/* 管理员卡片列表 */
.adminList {
  max-width: 800px;
  margin: 0 auto;
}
.adminCard {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  padding: 16px 20px;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  transition: box-shadow 0.2s;
}
.adminCard:hover {
  box-shadow: 0 6px 28px rgba(0, 0, 0, 0.12);
}
.adminCard_index {
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #4f46e5, #6366f1);
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
  margin-right: 16px;
  flex-shrink: 0;
}
.adminCard_info {
  flex: 1;
}
.infoRow {
  font-size: 14px;
  color: #333;
  line-height: 1.6;
}
.infoRow .label {
  color: #888;
}
.infoRow .value {
  color: #333;
}
.adminCard_actions {
  display: flex;
  gap: 12px;
  margin-left: 16px;
}
.actionBtn {
  font-size: 13px;
  cursor: pointer;
  transition: color 0.2s;
  padding: 4px 0;
}
.actionBtn.del {
  color: #ef4444;
}
.actionBtn.del:hover {
  color: #dc2626;
}
.actionBtn.edit {
  color: #4f46e5;
}
.actionBtn.edit:hover {
  color: #4338ca;
}

/* 弹窗样式 */
.overlayWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.block {
  width: 420px;
  background-color: #fff;
  border-radius: 16px;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.15);
  padding: 24px;
  box-sizing: border-box;
  position: relative;
}
.block_title {
  font-size: 17px;
  font-weight: 600;
  color: #1a1a1a;
  text-align: center;
  margin-bottom: 20px;
}
.block_tips {
  font-size: 12px;
  color: #bbb;
  text-align: center;
  margin-bottom: 16px;
}
.block_close {
  position: absolute;
  right: 16px;
  top: 16px;
  font-size: 24px;
  color: #999;
  cursor: pointer;
  transition: color 0.2s;
  line-height: 1;
}
.block_close:hover {
  color: #666;
}
.block_form {
  margin-top: 20px;
}
.field {
  margin-bottom: 14px;
  border: 1px solid #e4e8ef;
  border-radius: 10px;
  font-size: 14px;
}
.field:focus {
  border-color: #6366f1;
}
.confirmBtn {
  margin-top: 8px;
  background: linear-gradient(135deg, #4f46e5, #6366f1, #818cf8) !important;
  border: none !important;
  border-radius: 10px !important;
  font-weight: 600 !important;
  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.3) !important;
}
.confirmBtn:active {
  opacity: 0.9;
}
</style>